var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 67,
    viewBox: "0 0 102 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.123 53.3475C99.3709 53.3475 98.7613 52.7379 98.7613 51.986C98.7613 51.234 99.3709 50.6244 100.123 50.6244C100.875 50.6244 101.484 51.234 101.484 51.986C101.484 52.7379 100.875 53.3475 100.123 53.3475Z",
    fill: "#D6D9DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69904 43.09C6.38611 44.7005 10.2413 43.2117 10.2413 43.2117C10.2413 43.2117 9.73715 39.1125 7.04842 37.5038C4.36135 35.8934 0.507812 37.3803 0.507812 37.3803C0.507812 37.3803 1.01197 41.4795 3.69904 43.09Z",
    fill: "url(#paint0_linear_3772_700)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93085 29.6298C10.1251 30.3549 9.69483 31.1003 8.9697 31.2946C8.24457 31.4889 7.49923 31.0585 7.30493 30.3334C7.11063 29.6083 7.54096 28.8629 8.26608 28.6686C8.99121 28.4743 9.73655 28.9047 9.93085 29.6298Z",
    fill: "#D6D9DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9604 3.24339C62.1011 3.76835 61.7896 4.30795 61.2646 4.44861C60.7396 4.58927 60.2 4.27774 60.0594 3.75277C59.9187 3.22781 60.2303 2.68822 60.7552 2.54755C61.2802 2.40689 61.8198 2.71843 61.9604 3.24339Z",
    fill: "#D6D9DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.517 21.6895C87.301 21.6895 86.3153 22.6752 86.3153 23.8912C86.3153 25.1072 87.301 26.093 88.517 26.093C89.733 26.093 90.7188 25.1072 90.7188 23.8912C90.7188 22.6752 89.733 21.6895 88.517 21.6895Z",
    fill: "url(#paint1_linear_3772_700)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6875 14.5775C31.6865 14.5775 30.875 15.389 30.875 16.3901C30.875 17.3911 31.6865 18.2026 32.6875 18.2026C33.6885 18.2026 34.5 17.3911 34.5 16.3901C34.5 15.389 33.6885 14.5775 32.6875 14.5775Z",
    fill: "url(#paint2_linear_3772_700)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6156 50.8719C15.4757 50.8719 14.5515 49.9478 14.5515 48.8078C14.5515 47.6679 15.4757 46.7438 16.6156 46.7438C17.7556 46.7438 18.6797 47.6679 18.6797 48.8078C18.6797 49.9478 17.7556 50.8719 16.6156 50.8719Z",
    fill: "url(#paint3_linear_3772_700)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0367 36.5484C94.5047 36.5484 94.0735 36.1171 94.0735 35.5851C94.0735 35.0531 94.5047 34.6218 95.0367 34.6218C95.5687 34.6218 96 35.0531 96 35.5851C96 36.1171 95.5687 36.5484 95.0367 36.5484Z",
    fill: "url(#paint4_linear_3772_700)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54707 54.8474C8.5591 54.8474 7.7582 54.0465 7.7582 53.0586C7.7582 52.0706 8.5591 51.2697 9.54707 51.2697C10.535 51.2697 11.3359 52.0706 11.3359 53.0586C11.3359 54.0465 10.535 54.8474 9.54707 54.8474Z",
    fill: "#D6D9DC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.416 10.5344C88.58 10.5344 87.9023 9.85667 87.9023 9.02069C87.9023 8.18471 88.58 7.50702 89.416 7.50702C90.252 7.50702 90.9297 8.18471 90.9297 9.02069C90.9297 9.85667 90.252 10.5344 89.416 10.5344Z",
    fill: "#D6D9DC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5855 46.3839C90.8172 46.3839 90.1944 45.8857 90.1944 45.2711C90.1944 44.6564 90.8172 44.1582 91.5855 44.1582C92.3538 44.1582 92.9766 44.6564 92.9766 45.2711C92.9766 45.8857 92.3538 46.3839 91.5855 46.3839Z",
    fill: "#D6D9DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1067 12.3159H20.1266C20.2439 13.9784 21.4803 14.004 21.4803 14.004C21.4803 14.004 20.1169 14.0307 20.1169 15.9517C20.1169 14.0307 18.7534 14.004 18.7534 14.004C18.7534 14.004 19.9893 13.9784 20.1067 12.3159ZM19.2445 61.1315H19.2636C19.3761 62.789 20.5632 62.8146 20.5632 62.8146C20.5632 62.8146 19.2543 62.8411 19.2543 64.7564C19.2543 62.8411 17.9453 62.8146 17.9453 62.8146C17.9453 62.8146 19.1318 62.789 19.2445 61.1315Z",
    fill: "#D6D9DC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9613 29.2087V25.6658C79.9613 21.7508 76.7904 18.5797 72.8754 18.5797H57.0559C56.4727 18.5798 55.8986 18.436 55.3844 18.1609C54.8701 17.8859 54.4318 17.4882 54.1081 17.0031L49.1266 9.53084C48.8035 9.04507 48.3653 8.64664 47.8511 8.37099C47.3368 8.09533 46.7624 7.95097 46.179 7.95074H30.3595C26.4445 7.95074 23.2734 11.1218 23.2734 15.0368V60.5748C23.2734 62.8211 25.0911 64.6386 27.3373 64.6386C29.13 64.6386 30.7138 63.4624 31.2276 61.744L39.4721 34.261C40.3719 31.2601 43.1319 29.2087 46.2603 29.2087H81.127C85.8569 29.2087 89.2581 33.7508 87.926 38.2894L81.6868 59.5474C80.8011 62.566 78.034 64.6386 74.8878 64.6386H27.3373",
    stroke: "#D6D9DC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6431 5.31793L53.0503 1.74109C52.573 1.26638 51.9271 0.999931 51.2539 1H42.1424C40.7385 1 39.6016 2.13198 39.6016 3.52951V21.2366C39.6016 22.6342 40.7385 23.7662 42.1424 23.7662H54.8467C56.2506 23.7662 57.3877 22.6342 57.3877 21.2366V7.10635C57.3877 6.43605 57.1196 5.79226 56.6431 5.31793Z",
    fill: "white",
    stroke: "#D6D9DC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9966 14.2972L47.3642 16.9187C46.2236 17.5634 44.8125 16.7348 44.8125 15.4188V10.1767C44.8125 8.85961 46.2212 8.03205 47.3642 8.67675L51.9966 11.2983C53.1602 11.9546 53.1602 13.6386 51.9966 14.2972Z",
    fill: "url(#paint5_linear_3772_700)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7386 44.7694C52.1176 45.5146 47.7734 50.1449 47.7734 55.8067C47.7734 61.9857 52.9335 66.9964 59.2966 66.9964H84.6474C89.7384 66.9964 93.8659 62.9883 93.8659 58.0446C93.8659 53.1011 89.7384 49.093 84.6474 49.093C84.6474 41.6765 78.4572 35.6655 70.8197 35.6655C64.7424 35.6655 59.5939 39.4767 57.7386 44.7694Z",
    fill: "#63DAA5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7969 52.6861L70.2948 47.1128L75.7928 52.6861M70.2948 59.4644V47.7153",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3772_700",
    x1: 14.0974,
    y1: 48.2741,
    x2: -7.52388,
    y2: 28.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3772_700",
    x1: 93.9951,
    y1: 25.9992,
    x2: 82.9951,
    y2: 22.4992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3772_700",
    x1: 36.9971,
    y1: 17.9995,
    x2: 27.9971,
    y2: 15.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3772_700",
    x1: 19,
    y1: 51.0016,
    x2: 12,
    y2: 46.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3772_700",
    x1: 96.7424,
    y1: 37.0007,
    x2: 92.4941,
    y2: 34.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3772_700",
    x1: 38.9932,
    y1: 17.0002,
    x2: 66.4932,
    y2: 4.50024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.5b1f2cf0ee4c89b20f3b60254f99453d.svg";
export { ForwardRef as ReactComponent };